const pjson = require('../../package.json');
export const routesArray = pjson.reactSnap.include
export const homepage = process.env.PUBLIC_URL

export const development = process.env.REACT_APP_ENV === 'development' ? true : false
export const production = !development

export const isSnap = navigator.userAgent === 'ReactSnap' ? true : false
export const isBuild = process.env.REACT_APP_BLD === 'build' ? true : false

export const isMobile = navigator.userAgent.match(/mobile/im) ? true : false
export const hasVibrate = "vibrate" in navigator

export const baseURL = development ? 'https://testnew.templateroller.com' : 'https://www.templateroller.com'
export const apiURL = development ? 'https://microservicesdev.templateroller.com' : 'https://microservices.templateroller.com'

export const checkTimeout = 2000 // ms
export const uploadCloudTimeout = 1000 * 60 * 3 // ms

export const maxErrDefaultShowList = 4 // Максимальное количество ошибок в аплоаде, при котором лист будет открыт

export const carouselAutoplayDelay = 5000 //ms Автопрокрутка карусели на лэндинге

export const thumbStorageName = 'templateroller-tools-thumb'